import { Component } from '@angular/core';

@Component({
  selector: 'app-surveillances-link',
  templateUrl: './surveillances-link.component.html',
  styleUrls: ['./surveillances-link.component.scss']
})
export class SurveillancesLinkComponent {

}
